import { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import cn from './styles.local.less';

export default class ExteriorColorIcon extends Component {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const { className, name } = this.props;

    return <div className={cns(cn.root, cn[name], className)} />;
  }
}
